import React, { useState, createContext, useContext } from 'react';
import { IContent, appData } from './data';
import { useCookies } from 'react-cookie';

export const dictionaryList: any = { en: appData.en, tr: appData.tr };

export const languageOptions: any = {
  en: 'en',
  tr: 'tr'
};

interface IContext {
  userLanguage: string,
  data: IContent,
  changeLanguage?(selected: any): void,
}


export const Context = createContext<IContext>({
  userLanguage: 'tr',
  data: appData.tr
});


export function ContextProvider({ children }: any) {
  const [cookies, setCookie, removeCookie] = useCookies(['language']);
  const [userLanguage, setUserLanguage] = useState(cookies.language || 'tr');
  const [menuIsTransparent, setMenuTransparent] = useState(false);

  const provider: any = {
    userLanguage,
    languages: ['tr', 'en'],
    data: dictionaryList[userLanguage],
    changeLanguage: (selected: string) => {
      setUserLanguage(selected);
      //window.localStorage.setItem('rcml-lang', selected);
    },
    menuIsTransparent,
    setMenuTransparent: (transparency: boolean) => {
      setMenuTransparent(transparency);
      //window.localStorage.setItem('rcml-lang', selected);
    }
  };

  return (
    <Context.Provider value={provider}>
      {children}
    </Context.Provider>
  );
};
